<div class="campaign-creation-success-dialog">
  <div class="title-row" mat-dialog-titled fxLayout="row" fxLayoutAlign=" center">
    <h2 mat-dialog-title>
      @if (!isAbTest) {
        <span>{{ "widgets.campaigns.publish-success.title" | translate }}</span>
      }
      @if (isAbTest) {
        <span>{{ "widgets.campaigns.publish-success.abtest-title" | translate }}</span>
      }
    </h2>
    <span class="close-btn" (click)="dialogRef.close()"><mat-icon>close</mat-icon></span>
  </div>
  <mat-dialog-content>
    <div class="content-row">
      <div class="text-row">
        <p>
          @if (!isAbTest) {
            <span>
              @if (!(isSurveysPaused || isCouponSetPaused)) {
                {{ "widgets.campaigns.publish-success.text" | translate }}
              }
              @if (isSurveysPaused) {
                <span [innerHTML]="'widgets.campaigns.publish-success.surveys-over-limit-text' | translate: { daysUntilReset: daysUntilReset }"></span>
              }
              @if (isCouponSetPaused) {
                <span [innerHTML]="'widgets.campaigns.publish-success.coupons-over-limit-text' | translate"></span>
              }
            </span>
          }
          @if (isAbTest) {
            <span>{{ "widgets.campaigns.publish-success.abtest-text" | translate }}</span>
          }
        </p>
      </div>
      @if (!(isSurveysPaused || isCouponSetPaused)) {
        <div id="success_campaign_publish_modal" class="image-row">
          <img src="/assets/img/campaign/juhu.png" />
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="buttons-row">
      <button (click)="closeDialog()" class="underline-button close-btn">
        {{ "widgets.campaigns.publish-success.close-and-do-not-show" | translate }}
      </button>
      <app-campaign-preview
        [data]="campaignPreviewData"
        [accountHasVisits]="accountHasVisits"
        translationKey="widgets.campaigns.publish-success.btn-preview"
        [fillBackground]="true"></app-campaign-preview>
    </div>
  </mat-dialog-actions>
</div>
